import React from "react";
import { L } from "lib/translation";

class PriorityDropdown extends React.Component {
  constructor(props) {
    super(props);
  }

  async componentWillMount() {
    this.setState({ ready: true, currentValue: this.props.defaultValue });
  }

  setValue(e) {
    this.setState({ currentValue: e.target.value });

    if (this.props.updateParentState)
      this.props.updateParentState(e.target.value);
  }

  render() {
    if (!this.state || !this.state.ready) return <div />;

    return (
      <select
        id={this.props.id}
        defaultValue={this.props.defaultValue}
        onChange={this.setValue.bind(this)}
      >
        <L.option value="-" context="TalentManagement" useDashes="true">
          selectpriority
        </L.option>
        <L.option value="1" context="TalentManagement">
          low
        </L.option>
        <L.option value="2" context="TalentManagement">
          medium
        </L.option>
        <L.option value="3" context="TalentManagement">
          high
        </L.option>
      </select>
    );
  }
}

export default PriorityDropdown;
